import React from 'react';
import {
  Box,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { FONT_WEIGHT } from '../../theme/fonts';

export default function HomeSectionTwo() {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        py: { xs: 8, md: 12 },
      }}
    >
      {/* Animated gradient background */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(-45deg, #065f46, #047857, #0e918c, #0d9488)',
          backgroundSize: '400% 400%',
          animation: 'gradientShift 15s ease infinite',
          '@keyframes gradientShift': {
            '0%': { backgroundPosition: '0% 50%' },
            '50%': { backgroundPosition: '100% 50%' },
            '100%': { backgroundPosition: '0% 50%' },
          },
        }}
      />

      {/* Subtle overlay for text contrast */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.2) 100%)',
        }}
      />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        <Stack spacing={4} alignItems="center">
          {/* Mission Statement Header */}
          <Stack spacing={2} alignItems="center" textAlign="center" sx={{ maxWidth: 800 }}>
            <Typography
              variant="overline"
              sx={{
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: '0.85rem',
                fontWeight: FONT_WEIGHT.bold,
                letterSpacing: 3,
              }}
            >
              OUR MISSION
            </Typography>

            <Typography
              variant="h2"
              sx={{
                color: '#fff',
                fontWeight: FONT_WEIGHT.extraLight,
                fontSize: { xs: '2rem', md: '3rem' },
                lineHeight: 1.2,
                textShadow: '0 2px 20px rgba(0,0,0,0.2)',
              }}
            >
              Where civic actors connect, coordinate, and get results.
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontWeight: FONT_WEIGHT.regular,
                fontSize: { xs: '1rem', md: '1.25rem' },
                lineHeight: 1.7,
                maxWidth: 700,
              }}
            >
              CivixThread is one unified ecosystem connecting constituents, organizations, and
              public leaders. We provide role-based tools tailored to every account type and
              verify identities to ensure a trusted space.
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
